import React from 'react';
import styled, { css } from 'styled-components';
import { customScrollBar } from '../utils/styledComponentsUtils';

interface Props {
  children: Node | React.ReactNode;
  selectProps: {
    innerProps: {
      fallbackOptionMessage: string;
      onFallback: () => void;
      fallbackPlacement: 'bottom' | 'top';
    };
    innerRef: React.RefObject<HTMLDivElement>;
    onMenuClose: () => void;
    inputValue?: string;
  };
}

const SearchSelectCustomMenuList: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  selectProps,
}) => {
  const { innerProps, innerRef } = selectProps;
  const { fallbackOptionMessage, onFallback, fallbackPlacement } = innerProps;

  return (
    <StyledMenu className="Select__Custom-menu" ref={innerRef}>
      {fallbackPlacement === 'bottom' && children}
      {fallbackOptionMessage && (
        <StyledLink
          data-test-id="Select__Menu_Link"
          place={fallbackPlacement === 'bottom' ? 'top' : 'bottom'}
          onClick={() => onFallback()}
          dangerouslySetInnerHTML={{ __html: fallbackOptionMessage }}
        />
      )}
      {fallbackPlacement === 'top' && children}
    </StyledMenu>
  );
};

const StyledMenu = styled.div`
  position: relative;
  background-color: white;
  overflow-y: auto;
  max-height: 16rem;

  ${customScrollBar}
`;
const StyledLink = styled.a<{ place: 'bottom' | 'top' }>`
  background-color: white;
  min-height: 4.8rem;
  display: flex;
  align-items: center;
  padding: 0.4rem 1.8rem;
  cursor: pointer;

  ${({ place }) =>
    place === 'bottom' &&
    css`
      border-bottom: 1px solid #f0f1f3;
    `}
  ${({ place }) =>
    place === 'top' &&
    css`
      border-top: 1px solid #f0f1f3;
    `}
  
  & span {
    color: ${({ theme }) => theme.brand.primary};
    margin-left: 0.4rem;

    &.bold {
      font-weight: 500;
    }

    &:hover {
      text-decoration: underline;
    }
  }
`;

export default SearchSelectCustomMenuList;
